import VendorUtil from '@utils/vendorUtils';

// const BASE_API_URL = process.env.NEXT_PUBLIC_API_URL;
const BASE_API_URL = VendorUtil.generateApiUrl(process.env.NEXT_PUBLIC_API_URL || '');

const NATS_API_URL = process.env.NEXT_PUBLIC_NATS_API_URL;
const SIGNALR_API_URL = process.env.NEXT_PUBLIC_SIGNALR_API_URL;
const REPORT_API_URL = process.env.NEXT_PUBLIC_REPORT_API_URL;
const BIKER_API_URL = process.env.NEXT_PUBLIC_BIKER_APP;
export { BASE_API_URL, REPORT_API_URL, SIGNALR_API_URL, BIKER_API_URL, NATS_API_URL };
